import { isEmpty } from 'lodash';
import { Accident } from '../../types/accident';
import { SameAsValue } from '../AccidenCreatingStepCustomerInformations';

export const isOperatorSameAsUser = (accident?: Accident): boolean => {
  // Iniciální stav nebo prázdný operator = stejný jako majitel
  if (!accident?.user || isEmpty(accident.operator)) return true;

  if ((accident.operator as any).equalTo === 'user') {
    return true;
  }

  if (accident.operator.id && accident.user.id) {
    return accident.operator.id === accident.user.id;
  }

  return false;
};

export const getDriverSameAs = (accident?: Accident): SameAsValue => {
  if (!accident?.driver) return 'user';

  const driverEqualTo = (accident.driver as any).equalTo;
  if (driverEqualTo === 'user' || driverEqualTo === 'operator' || driverEqualTo === 'none') {
    return driverEqualTo;
  }

  return 'user';
};

export const getContactPersonSameAs = (accident?: Accident): SameAsValue => {
  if (!accident?.contactPerson) return 'user';

  const contactEqualTo = (accident.contactPerson as any).equalTo;
  if (
    contactEqualTo === 'user' ||
    contactEqualTo === 'operator' ||
    contactEqualTo === 'driver' ||
    contactEqualTo === 'none'
  ) {
    return contactEqualTo;
  }

  return 'user';
};

export const initializeSameAsValues = (accident?: Accident) => {
  return {
    operatorSameAsOwner: isOperatorSameAsUser(accident),
    driverSameAsOwner: getDriverSameAs(accident),
    contactSameAsOwner: getContactPersonSameAs(accident)
  };
};
